
/*
*
* File JS per la HomePage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import heroHomepage from 'components/heroes/hero-homepage';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
heroHomepage();
});

//--------------------------------------------------------------------//